import { render } from "./StockRelat.vue?vue&type=template&id=a8e20a9e"
import script from "./StockRelat.vue?vue&type=script&lang=js"
export * from "./StockRelat.vue?vue&type=script&lang=js"

import "./StockRelat.vue?vue&type=style&index=0&id=a8e20a9e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__